import { useEffect, useState } from "react";
import { X } from "lucide-react";

const KEY = "e2e_cookie_notice_dismissed_v1";

export default function CookieNotice() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => {
      if (!localStorage.getItem(KEY)) setVisible(true);
    }, 900);
    return () => clearTimeout(t);
  }, []);

  const dismiss = () => {
    localStorage.setItem(KEY, "1");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-notice"
      className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:max-w-md z-40"
    >
      <div className="bg-[#0a0a0a] border border-white/12 shadow-2xl px-5 py-4 flex items-start gap-4">
        <p className="font-body text-sm text-white/75 leading-relaxed flex-1">
          We use cookies and privacy-respecting analytics to understand what resonates
          and improve the site. By using Employee 2 Employer you agree to our{" "}
          <a href="/privacy" className="text-[#D4AF37] hover:underline">
            privacy policy
          </a>
          .
        </p>
        <button
          onClick={dismiss}
          data-testid="cookie-notice-dismiss"
          aria-label="Dismiss notice"
          className="text-white/50 hover:text-[#D4AF37] transition-colors shrink-0"
        >
          <X size={18} />
        </button>
      </div>
    </div>
  );
}
